import { GridContainer, GridItem } from "@duosoftbg/nacid-components";
import { Typography } from "@mui/material";
import React, { Fragment } from "react";
import ScrollableGridContainer from "../../../../common/grid/ScrollableGridContainer";

const InheritedRolesContent = ({ group }) => {
  return (
    <ScrollableGridContainer>
      <GridContainer spacing={3} mt={0}>
        <GridItem sm={12} md={12} style={{ marginLeft: "10px" }}>
          <Typography variant="h6" gutterBottom component="span">
            {group?.parentGroups?.map((x, i) => {
              return (
                <Fragment key={"inherited-roles-" + x.id}>
                  {group?.inheritedRoles[x.name].length > 0 && (
                    <Typography variant="h6" gutterBottom component="div">
                      {x.name}
                    </Typography>
                  )}
                  {group?.inheritedRoles[x.name].map((role, index) => {
                    return (
                      <Fragment key={"roles-" + role.id}>
                        <Typography variant="subtitle1" gutterBottom component="span">
                          {role.name}
                        </Typography>
                        {index < group?.inheritedRoles[x.name].length - 1 && (
                          <Typography variant="subtitle1" gutterBottom component="span">
                            {", "}
                          </Typography>
                        )}
                      </Fragment>
                    );
                  })}
                </Fragment>
              );
            })}
          </Typography>
        </GridItem>
      </GridContainer>
    </ScrollableGridContainer>
  );
};

export default InheritedRolesContent;
